import React from "react";
import ins1 from "../assets/images/ins1.jpeg";
import ins2 from "../assets/images/ins2.jpeg";
import ins3 from "../assets/images/ins3.jpeg";
import ins4 from "../assets/images/ins4.jpeg";
import ins5 from "../assets/images/ins5.jpeg";
import ins6 from "../assets/images/ins6.jpeg";
import ins7 from "../assets/images/ins7.jpeg";
import ins8 from "../assets/images/ins8.jpeg";

const instructors = [
  {
    name: "A B M Kalim Ullah",
    title: "FCS, PMP, ITP",
    img: ins1,
    bio: "With extensive experience in accounting and finance, he guides students to excel professionally.",
  },
  {
    name: "Md. Abu Naser",
    title: "ACMA, ITP, PGDTM",
    img: ins2,
    bio: "ICAB Professional-Level | Member, Dhaka Taxes Bar Association. Expert in taxation and finance training.",
  },
  {
    name: "Rahat Mahmud MBM",
    title: "(BIBM) MSS (DU) ICSB (P1)",
    img: ins5,
    bio: "Group Company Secretary at Aftab Automobiles Limited (Navana Group). Chief Consultant at Conservative Management.",
  },
  {
    name: "Md. Abdur Rob",
    title: "FCS, CGIA, ABIA",
    img: ins4,
    bio: "Company Secretary, IPE Group. Provides professional guidance in company law, governance, and compliance.",
  },
  {
    name: "Jakaria Kowser",
    title: "VC, ITP, LLB",
    img: ins3,
    bio: "ICSB Partly Qualified | Member, Dhaka Taxes Bar Association. Focused on business law and corporate training.",
  },
  {
    name: "Abdullah Al Hadi",
    title: "Advocate at Supreme Court of Bangladesh",
    img: ins6,
    bio: "Renowned legal expert practicing in the Supreme Court of Bangladesh with a focus on corporate and taxation law.",
  },
  {
    name: "Md. Anwar Hossain",
    title: "VC, ITP and CEO, Consulting Firm",
    img: ins7,
    bio: "Experienced business leader and consultant specializing in taxation, corporate management, and entrepreneurship.",
  },
  {
    name: "Depesh Banik",
    title: "PMI ACP, PMI DASM, ISCEA-CPLM, PMO, Webb Fontaine",
    img: ins8,
    bio: "Certified project management professional with extensive expertise in supply chain and digital transformation.",
  },
];

const MeetInstructors = () => {
  // Duplicate instructors to create infinite loop
  const loopedInstructors = [...instructors, ...instructors];

  return (
    <section style={{ padding: "60px 20px", backgroundColor: "#f8f9fa" }}>
      {/* Header */}
      <div
        style={{
          backgroundColor: "#0d6efd",
          color: "white",
          padding: "40px 30px",
          borderTopLeftRadius: "40px",
          borderBottomRightRadius: "10px",
          marginBottom: "50px",
        }}
      >
        <h2 style={{ fontSize: "32px", marginBottom: "15px", fontWeight: "700" }}>
          Meet Our Instructors
        </h2>
        <p style={{ fontSize: "16px", lineHeight: "1.6", margin: 0 }}>
          Our team of expert instructors will guide you to achieve professional excellence.
        </p>
      </div>

      {/* Infinite scroll container */}
      <div
        style={{
          overflow: "hidden",
          position: "relative",
        }}
      >
        <div
          style={{
            display: "flex",
            gap: "30px",
            width: "max-content",
            animation: "scrollLoop 20s linear infinite",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.animationPlayState = "paused")}
          onMouseLeave={(e) => (e.currentTarget.style.animationPlayState = "running")}
        >
          {loopedInstructors.map((inst, index) => (
            <div
              key={index}
              style={{
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                width: "260px",
                flexShrink: 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img
                src={inst.img}
                alt={inst.name}
                style={{
                  width: "120px",
                  height: "120px",
                  objectFit: "cover",
                  borderRadius: "50%",
                  marginBottom: "20px",
                  border: "3px solid #0d6efd",
                }}
              />
              <h3
                style={{
                  fontSize: "20px",
                  fontWeight: "700",
                  marginBottom: "8px",
                  textAlign: "center",
                }}
              >
                {inst.name}
              </h3>
              <p
                style={{
                  fontSize: "15px",
                  color: "#0d6efd",
                  fontWeight: "600",
                  marginBottom: "12px",
                  textAlign: "center",
                }}
              >
                {inst.title}
              </p>
              <p
                style={{
                  fontSize: "14px",
                  color: "#555",
                  lineHeight: "1.5",
                  margin: 0,
                  textAlign: "center",
                  whiteSpace: "normal",
                  wordWrap: "break-word",
                }}
              >
                {inst.bio}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Keyframes */}
      <style>
        {`
          @keyframes scrollLoop {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}
      </style>
    </section>
  );
};

export default MeetInstructors;
